const PublicRouteNoHeader = ({ children }) => children;
export default PublicRouteNoHeader;